export enum NavigationMenu {
  MAIN,
  SETTINGS
}
